/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncNewFreeBetsPopup = async(() =>
  import('@xanadu/ui-shared/components/FreeBetsPopup').then((module) => module.default)
);

const FreeBetsPopupWrapper = ({ closeModal, history: { push: navigate } }) => {
  const onPrimaryActionClick = () => {
    navigate('/account');
  };

  return (
    <AsyncNewFreeBetsPopup onPrimaryActionClick={onPrimaryActionClick} closeModal={closeModal} />
  );
};

FreeBetsPopupWrapper.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  closeModal: PropTypes.func.isRequired,
};

export default withRouter(React.memo(FreeBetsPopupWrapper));
